import { useSelector } from 'react-redux'
import { ThemeProvider } from '@mui/material/styles'
import { currentTheme } from './reducers/sliceReducer'
import { lightTheme, darkTheme } from './utilities/themes'
import { BrowserRouter as Router } from 'react-router-dom'
import { renderRoutes } from 'react-router-config'
import { AlertContextProvider } from './components/AlertContext'
import Snackbar from './components/Snackbar'
import Alert from './components/Alert'
import routes from './routes'

function App() {
  const isDarkTheme = useSelector(currentTheme)
  const theme = isDarkTheme ? darkTheme : lightTheme

  return (
    <ThemeProvider theme={theme}>
      <AlertContextProvider>
        <Router>{renderRoutes(routes)}</Router>
        <Snackbar />
        <Alert />
      </AlertContextProvider>
    </ThemeProvider>
  )
}

export default App
